const slugify = require('slugify')
const pathPrefix = '/blog'
const ACTUAL_DATE = '2019-09-01T00:00:00.674Z'

const isOldBlog = dateString => {
  const actualDate = new Date(ACTUAL_DATE)
  const createDate = new Date(dateString)

  return createDate.getTime() < actualDate.getTime()
}

exports.createUrl = (legacy, legacyTitle, category, title, createdAt, slug) => {
  let originalPath = `${pathPrefix}/${slug}/`
  if (isOldBlog(createdAt)) {
    console.log('Old blog post', legacy, legacyTitle, title)
    if (!!legacy) {
      const splitSlugArray = legacyTitle.split('-')
      const slug = `${splitSlugArray[0]}/${splitSlugArray[1]}/${
        splitSlugArray[2]
      }/${splitSlugArray.slice(3, splitSlugArray.length).join('-')}`
      originalPath = `/${category}/${slug}/`
    } else {
      console.log('Old post, not legacy', legacyTitle, title, '\n')
      const slug = slugify(legacyTitle)
      originalPath = `${pathPrefix}/${slug}/`
    }
  }
  return originalPath
}

exports.createShoeUrl = (slug, title) => {
  const url = !!slug
    ? `${pathPrefix}/${slug}/`
    : `${pathPrefix}/${slugify(title.toLowerCase())}/`
  return url
}
